const activityEventUserType = {
    AUTHENTICATION_RULES : 'AUTHENTICATION_RULES',

    AUTHENTICATION_SERVER : 'AUTHENTICATION_SERVER',

    AGENT : 'Agent',

    UNDERWRITER : 'Underwriter',

    SERVICE_USER : 'Service User',

    RULES : 'Rules',

    SYSTEM : 'System'

};

angular.module('gw-um-j2js')
    .constant('activityEventUserType', activityEventUserType);